import { Button } from 'antd'
import React from 'react'
import { useLazyCreateUsersExportQuery } from '../../api/v2/users'
import { useMyContext } from '../../context/context'
import { useUsers } from './useUsers'

export default function ExportUsers() {
  const { myContext } = useMyContext()
  const { usersHeaders, usersFilters } = useUsers()

  const [createExport, { data: url, isFetching }] = useLazyCreateUsersExportQuery()

  if (url) {
    return (
      <Button size="small" type="primary" href={url}>
        Télécharger l'export
      </Button>
    )
  }

  return (
    <Button size="small" loading={isFetching} onClick={() => createExport({ ...myContext, filters: usersFilters, headers: usersHeaders })}>
      {isFetching ? 'Génération du fichier...' : 'Créer un export'}
    </Button>
  )
}
